const ServicesLearnMoreLink = () => (
  <a
    href="https://ncx.com/services/"
    rel="noopener noreferrer"
    target="_blank"
    className="link ncx-services-learn-more"
    data-testid="services-learn-more-link"
  >
    View more services
  </a>
)

export default ServicesLearnMoreLink
